import { useMemo } from 'react';

import moment from 'moment';

import useForm from '../utils/useForm';
import LoanService from '../../services/LoanService';

const useClaimForm = (onSubmit, values, loanId, readOnly) => {
  const fields = useMemo(
    () => [
      {
        title: values?.id ? 'Edit Claim' : 'Create Claim',
        fields: [
          {
            title: 'Date Submitted',
            name: 'date_submitted',
            type: 'date',
            required: true,
          },
          {
            title: 'Date of Loss',
            name: 'date_of_loss',
            type: 'date',
            required: true,
          },
          {
            title: 'Insurance Policy',
            name: 'insurance_id',
            type: 'fetchableSelect',
            fetchOptions: {
              key: ['insurances', loanId],
              queryFn: () => LoanService.getLoanInsurances(loanId),
              labelKey: (insurance) =>
                `${insurance.policy_number}${
                  insurance.start_date
                    ? ` starting ${moment(insurance.start_date).format(
                        'M/D/YY'
                      )}`
                    : ''
                }`,
            },
            required: true,
          },
          {
            title: 'Status',
            name: 'status',
            type: 'select',
            required: true,
            options: [
              { value: 'active', label: 'Active' },
              { value: 'cancelled', label: 'Cancelled' },
              { value: 'complete', label: 'Complete' },
            ],
          },
          {
            title: 'Cause',
            name: 'cause',
            type: 'select',
            options: [
              { value: 'WIND_HAIL', label: 'Wind or Hail' },
              { value: 'FIRE', label: 'Fire' },
              { value: 'FLOOD', label: 'Flood' },
            ],
            readOnly,
            isHidden: () => readOnly && !values?.id,
          },
          {
            title: 'Amount',
            name: 'claim_amount',
            type: 'currency',
            readOnly,
            isHidden: () => readOnly && !values?.id,
          },
        ],
      },
    ],
    [loanId, readOnly, values?.id]
  );

  return useForm({ fields, onSubmit, values });
};

export default useClaimForm;
